import React, { useEffect, useMemo, useState } from 'react';

import { Home } from '@mui/icons-material';
import dayjs from 'dayjs';
import { Row, Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

import { getList, getBranchPushNotifications } from './operations';
import { Button, PushNotificationsHeader, BranchPushNotificationsTable, SubHeader, Footer } from '../../../components';
import pushNotificationsOptions from '../pushNotificationsOptions';

import './styles.scoped.css';

const utc = require('dayjs/plugin/utc');

dayjs.extend(utc);

const BranchPushNotifications = () => {
  const navigate = useNavigate();
  const { statuses } = pushNotificationsOptions;
  const [form, setForm] = useState({});
  const [branches, setBranches] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const [isLoadingBranches, setIsLoadingBranches] = useState(false);
  const [notifications, setNotifications] = useState([]);

  const nextToken = null;
  let prevToken = null;

  const formFilters = () => {
    const filters = {};

    if (form) {
      filters.type = { eq: 'Branch' };
      filters.subject = { ne: 'Driver Survey' };
    }

    if (form.branch) {
      filters.branch = { contains: form?.branch };
    }

    if (form?.status !== undefined && form?.status !== '' && form?.status !== null) {
      filters.status = { eq: form?.status };
    }

    if (form?.createdAtStartDate && form?.createdAtEndDate) {
      const startDate = dayjs(form?.createdAtStartDate).startOf('day').toISOString();
      // Set the end date to the end of the day
      const endDate = dayjs(form?.createdAtEndDate).endOf('day').toISOString();
      filters.createdAt = { between: [`${dayjs.utc(startDate).format()}`, `${dayjs.utc(endDate).format()}`] };
    }

    return filters;
  };

  const getFilteredNotifications = async token => {
    const filters = formFilters();
    const newNotifications = await getBranchPushNotifications(filters, token);

    return {
      list: newNotifications?.items,
      tokenResult: newNotifications?.nextToken,
    };
  };

  const getBatch = async (aNextToken = undefined) => {
    if (prevToken !== aNextToken) {
      prevToken = aNextToken;

      const response = await getFilteredNotifications(aNextToken);
      const items = response?.list;
      const token = response?.tokenResult;

      console.log('items:', items);
      console.log('token', token);
      if (token !== null) {
        getBatch(token);
        if (items) {
          setNotifications([items, ...items]);
        }
      } else {
        setIsSearching(false);
      }
    }
  };

  const handleSearch = async () => {
    setIsSearching(true);
    const response = await getFilteredNotifications(nextToken);

    if (Array.isArray(response?.list) && response?.list.length > 0) {
      setNotifications([...response.list]);
      setIsSearching(false);
    } else {
      getBatch(response?.tokenResult);
    }
  };

  const handleGetBranches = async () => {
    setIsLoadingBranches(true);
    const response = await getList('branches');
    setBranches(response);
    setIsLoadingBranches(false);
  };

  const branchOptions = useMemo(
    () =>
      branches?.map(({ BranchName, Branch }) => ({
        label: BranchName,
        value: Branch,
      })),
    [branches],
  );

  const convertArrayToObject = items => {
    const arr = [];
    let branch = {};

    if (items) {
      String(items)
        .split(', ')
        ?.forEach(i => {
          branch = branches?.find(option => String(option.Branch) === i);
          arr.push({
            label: branch?.BranchName,
            value: branch?.Branch,
          });
        });
    }

    return arr;
  };

  useEffect(() => {
    handleGetBranches();
    handleSearch();
  }, []);

  return (
    <>
      <SubHeader
        text="Push Notifications"
        buttons={[
          { icon: <Home sx={{ color: '#fff', fontSize: 30 }} />, onPress: () => navigate('/push-notifications') },
        ]}
      />

      <div className="wrap">
        <PushNotificationsHeader
          form={form}
          setForm={setForm}
          branches={branchOptions}
          isLoadingBranches={isLoadingBranches}
          setIsSearching={setIsSearching}
          setNotifications={setNotifications}
          route="add-branch-push-notification"
          statuses={statuses}
          title="Branch Push Notifications"
          handleSearch={handleSearch}
          convertArrayToObject={convertArrayToObject}
        />

        {Array.isArray(notifications) && !isSearching ? (
          <BranchPushNotificationsTable
            data={notifications}
            editRoute="/push-notifications/branch-push-notifications/edit-branch-push-notification"
          />
        ) : (
          <div className="h-100 d-flex justify-content-center p-5">
            <Spinner animation="border" />
          </div>
        )}

        <Row className="justify-content-center">
          <Button
            variant="outline"
            onPress={() => {
              navigate('/push-notifications');
            }}
            text="Cancel"
          />
        </Row>
      </div>

      <Footer />
    </>
  );
};

export default BranchPushNotifications;
